import { render, staticRenderFns } from "./WflowFormList.vue?vue&type=template&id=641f55ae&scoped=true"
import script from "./WflowFormList.vue?vue&type=script&lang=js"
export * from "./WflowFormList.vue?vue&type=script&lang=js"
import style0 from "./WflowFormList.vue?vue&type=style&index=0&id=641f55ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f55ae",
  null
  
)

export default component.exports